/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */

// Turns standard contact seller / send message links
// into ajaxified ones.
function bindSendMessageLinks() {
  $(document).on('click', 'a[data-send-message]', function (e) {
    e.stopPropagation();
    e.preventDefault();
    Reverb.UI.Ajax.lightbox($(this).prop('href'));
  });
}

function toggleNegotiationForm() {
  $('[data-toggle-disabled-on-click]').on('click', function () {
    $('[data-negotiationform]').find(':input').each(function () {
      $(this).prop('disabled', function (_, value) { return !value; }).trigger('liszt:updated');
    });
  });
}

function toggleSubmitButtonMessage() {
  $('[data-toggle-submit-button-message]').on('click', function () {
    const submitButton = $(this).parents('form').find('input[type="submit"]');
    const message = $(this).data('toggle-submit-button-message');
    submitButton.toggleClass('btn-primary').toggleClass('btn-blue');
    submitButton.val(message);
    $('.message-with-offer').slideToggle(300);
  });
}

function showAjaxMessageSubmitSuccess() {
  $(document).on('ajax:complete', 'form#new_message', function (_e, xhr) {
    $.fancybox.close();
    if (xhr.status === 403 || xhr.status === 401) {
      Reverb.UI.show_flash_message(xhr.responseText, 'error');
    } else {
      Reverb.UI.show_flash_message(xhr.responseText, 'success');
    }
  });
}

function init() {
  bindSendMessageLinks();
  toggleNegotiationForm();
  toggleSubmitButtonMessage();
  showAjaxMessageSubmitSuccess();
}

export default {
  init,
};

/* eslint-enable func-names */
/* eslint-enable prefer-arrow-callback */



// WEBPACK FOOTER //
// ./javascripts/components/legacy/messages.js